import theme from '../../../theme';

// Shared Leaflet-popup card styles for DriverPopupContent (dpc-*) and
// StopPopupContent (spc-*): card root plus the name/row/label/value blocks.
// Class names stay per-component-prefixed to avoid selector cascade
// collisions (see CLAUDE.md), so the shared block is keyed by prefix; each
// popup spreads this base and adds its own extra classes.
export default function popupCardBase(prefix) {
  return {
    padding: '12px 14px',
    fontSize: theme.sizes.smallFontSize,
    color: theme.colors.textBody,
    lineHeight: 1.4,

    // Names are often raw location ids with no spaces
    // (IL_TARGET_T3317__2434_N_SACRAMENTO_AVE) — break them anywhere so they
    // wrap inside the popup instead of running under the close button.
    [`& .${prefix}-name`]: {
      fontSize: theme.sizes.bodyFontSize,
      fontWeight: theme.fontWeights.semibold,
      color: theme.colors.textDark,
      marginBottom: '2px',
      paddingRight: theme.spacing.popupCloseGap,
      overflowWrap: 'anywhere',
    },
    [`& .${prefix}-row`]: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '12px',
      padding: '2px 0',
    },
    [`& .${prefix}-label`]: {
      color: theme.colors.textMuted,
      fontSize: theme.sizes.captionFontSize,
      flexShrink: 0,
    },
    [`& .${prefix}-value`]: {
      fontWeight: theme.fontWeights.medium,
      fontVariantNumeric: 'tabular-nums',
      textAlign: 'right',
      minWidth: 0,
      overflowWrap: 'anywhere',
    },
  };
}
